import { useEffect, useRef } from "react";
import { HubSpotChatClass } from "./hubspot";

declare global {
  interface Window {
    intercomSettings?: { app_id: string };
    Intercom?: (...args: any[]) => void;
  }
}

export interface UseChatIntegrationParams {
  userEmail?: string;
  enableAnonymousChat?: boolean;
}

export function useChatIntegration({ userEmail, enableAnonymousChat }: UseChatIntegrationParams) {
  const chatClassRef = useRef<HubSpotChatClass | null>(null);

  // Handle initialization and updates to userEmail
  useEffect(() => {
    // If no chat class, create one
    if (!chatClassRef.current) {
      chatClassRef.current = new HubSpotChatClass(userEmail);
    }
    const chat = chatClassRef.current;

    // If chat script is not yet inserted, initialize it if we have an email or anonymous chat is enabled
    if (!chat.isInserted() && (userEmail || enableAnonymousChat)) {
      chat.initialize(userEmail);
    }

    // If already inserted, just update the email
    if (chat.isInserted() && userEmail && !chat.getEmail()) {
      chat.setEmail(userEmail);
    }
  }, [userEmail, enableAnonymousChat]);

  return { chat: chatClassRef.current };
}
